function parseEnderecoComposto(raw, knownBairro = '') {
  const s = String(raw ?? '').trim();
  if (!s) return { logradouro: '', numero: '', bairro: knownBairro };

  let head = s;
  const tailMatch = s.match(/^(.+?),\s*[^,]+\s*-\s*[A-Za-z]{2}\s*(?:,?\s*\d{5}-?\d{3})?\s*$/);
  if (tailMatch) head = tailMatch[1].trim();

  const commaIdx = head.indexOf(',');
  if (commaIdx === -1) {
    return { logradouro: head, numero: '', bairro: knownBairro };
  }

  const logradouro = head.slice(0, commaIdx).trim();
  const rest = head.slice(commaIdx + 1).trim();
  const numBairro = rest.match(/^(\S+)\s+(.+)$/);
  if (numBairro) {
    return {
      logradouro,
      numero: numBairro[1].trim(),
      bairro: numBairro[2].trim() || knownBairro,
    };
  }
  return { logradouro, numero: rest, bairro: knownBairro };
}

/** Formato: "logradouro, numero - bairro" a partir dos campos da OS. */
export function formatOrderStreetAddress(order) {
  const knownBairro = String(order?.TB02115_BAIRRO ?? order?.bairro ?? '').trim();
  let logradouro = String(order?.TB02115_END ?? order?.logradouro ?? '').trim();
  let numero = String(order?.TB02115_NUM ?? order?.numero ?? '').trim();
  let bairro = knownBairro;

  const rawEndereco = String(order?.endereco ?? order?.ENDERECO ?? '').trim();
  if ((!logradouro || !numero) && rawEndereco) {
    const parsed = parseEnderecoComposto(rawEndereco, knownBairro);
    logradouro = logradouro || parsed.logradouro;
    numero = numero || parsed.numero;
    bairro = parsed.bairro || bairro;
  }

  if (!logradouro && !numero && !bairro) {
    const raw = String(order?.endereco ?? order?.ENDERECO ?? '').trim();
    return raw || 'Endereço não informado';
  }

  const streetPart = [logradouro, numero].filter(Boolean).join(', ');
  if (bairro) return streetPart ? `${streetPart} - ${bairro}` : bairro;
  return streetPart || 'Endereço não informado';
}

/** Quebra endereço da OS em linhas para exibição no modal V2. */
export function parseOrderAddressLines(order) {
  const raw = String(order?.endereco ?? '').trim();
  const cidade = String(order?.TB02115_CIDADE || order?.cidade || '').trim();
  const estado = String(order?.TB02115_ESTADO || order?.estado || '').trim();
  const local12 = String(order?.TB02112_LOCAL ?? '').trim();
  const local15 = String(order?.TB02115_LOCAL ?? '').trim();

  const line1 = raw || 'Endereço não informado';
  let line2 = '';
  if (cidade || estado) {
    const parts = [cidade, estado].filter(Boolean);
    line2 = parts.join(', ');
    const cepMatch = raw.match(/\b\d{5}-?\d{3}\b/);
    if (cepMatch && !line2.includes(cepMatch[0])) {
      line2 = line2 ? `${line2} - ${cepMatch[0]}` : cepMatch[0];
    }
  }

  const localLine = local15 || local12 || '';
  return { line1, line2, localLine };
}
